import { useState } from "react";
import {
  FormControl,
  FormLabel,
  CheckboxGroup,
  Checkbox,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverArrow,
  PopoverCloseButton,
  Button,
  VStack,
  Box
} from "@chakra-ui/react";

const MultiSelectDropdown = ({ merchants, currentCategory, setCurrentCategory }) => {
  const [selectedMerchants, setSelectedMerchants] = useState(currentCategory.merchant);

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    const updatedMerchants = checked
      ? [...selectedMerchants, value]
      : selectedMerchants.filter((merchantId) => merchantId !== value);

    setSelectedMerchants(updatedMerchants);
    setCurrentCategory({ ...currentCategory, merchant: updatedMerchants });
  };

  return (
    <FormControl isRequired width={"30%"}>
      <FormLabel>Merchants</FormLabel>
      <Popover>
        <PopoverTrigger>
          <Button width="full" colorScheme="teal" size="sm">
            Select Merchants
          </Button>
        </PopoverTrigger>
        <PopoverContent>
          <PopoverArrow />
          <PopoverCloseButton />
          <Box p={4} maxHeight="200px" overflowY="auto">
            <CheckboxGroup value={selectedMerchants}>
              <VStack align="start">
                {merchants.map((merchant) => (
                  <Checkbox
                    key={merchant.id}
                    value={merchant.id}
                    onChange={handleCheckboxChange}
                    isChecked={selectedMerchants.find((merc)=>merc.id === merchant.id)?true:false}
                  >
                    {merchant.name}
                  </Checkbox>
                ))}
              </VStack>
            </CheckboxGroup>
          </Box>
        </PopoverContent>
      </Popover>
    </FormControl>
  );
};

export default MultiSelectDropdown;
